import React from 'react';

/** The supplied lockup artwork, navy on transparent. Kept for print and social use. */
export const LOGO_LOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/nTjBqcuuXgbjSwDzeQVhBn/Cavalla.png';
type LogoVariant = 'light' | 'reversed' | 'mark' | 'tile';
interface LogoProps {
  variant?: LogoVariant;
  className?: string;
}

/**
 * The Cavalla mark: an open crescent forming a C, crossed by a fine swoosh
 * that terminates in a single gold dot.
 */
export function CavallaMark({
  colour = '#F2F6FB',
  className = ''
}: {
  colour?: string;
  className?: string;
}) {
  return <svg viewBox="0 0 100 100" className={className} aria-hidden="true" focusable="false" data-id="element-61" data-mp="13y08fqwkwe8f">
      <path fill={colour} fillRule="evenodd" d="M50 50 m-46 0 a46 46 0 1 0 92 0 a46 46 0 1 0 -92 0 M63 50 m-38 0 a38 38 0 1 0 76 0 a38 38 0 1 0 -76 0" data-id="element-62" data-mp="18wtmbkfs2794" />
      <path d="M13 70 C33 96 74 95 89 60" fill="none" stroke={colour} strokeWidth="3.4" strokeLinecap="round" data-id="element-63" data-mp="2fezysgzd8izt" />
      <circle cx="89" cy="60" r="8" fill="#FF5C1A" data-id="element-64" data-mp="1wwh5pp39ghlj" />
    </svg>;
}
export function Logo({
  variant = 'light',
  className = ''
}: LogoProps) {
  if (variant === 'mark') {
    return <span className={`inline-flex ${className}`} role="img" aria-label="Cavalla Solution" data-id="element-65" data-mp="1nw2igk6qksfe">
        <CavallaMark className="h-9 w-9" data-id="element-66" data-mp="1iyafmv4jzlwf" />
      </span>;
  }
  if (variant === 'tile') {
    return <span className={`inline-flex h-10 w-10 items-center justify-center rounded-[10px] bg-charcoal ${className}`} role="img" aria-label="Cavalla Solution" data-id="element-67" data-mp="1dyxrm71y48s9">
        <CavallaMark colour="#FFFFFF" className="h-7 w-7" data-id="element-68" data-mp="148cy2y14pug7" />
      </span>;
  }

  // Every surface is now dark, so the navy lockup artwork would disappear. The
  // light variant falls through to the reversed mark, which is drawn in code and
  // holds at any size. The artwork URL is kept for print and social use.
  return <span className={`inline-flex items-center gap-2.5 ${className}`} role="img" aria-label="Cavalla Solution" data-id="element-69" data-mp="qaeijpb2nrz4">
      <CavallaMark colour="#FFFFFF" className="h-8 w-8 shrink-0" data-id="element-70" data-mp="gjwm98hu0c6z" />
      <span className="font-display text-[22px] font-medium leading-none tracking-[-0.02em] text-white" data-id="element-71" data-mp="lku9w0lm1yfv">
        Cavalla
      </span>
    </span>;
}